// @ts-ignore
import { setupEditorHost } from '@card/editor-host/setup-editor-host';
import { Def } from '@card/common/definitions';
import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";

@Component({
    selector: 'app-card-number-host',
    template: require('./card-number-host.component.html')
})
export class CardNumberHostComponent implements OnInit, AfterViewInit {

    @Input() cardUrl: string
    @Input() height: string
    @Input() className: string
    @Input() tid: string

    @ViewChild('cardNumberHostIframe') private hostIframe: ElementRef;

    editorCreator: Def.CreateEditor
    iFrameHeight: string;
    errorMessage: string | null = null;
    hasBeenTouched: boolean = false;

    ngOnInit() {
        this.iFrameHeight = this.height || '74px';
    }

    ngAfterViewInit(): void {
        this.editorCreator = setupEditorHost(this.hostIframe.nativeElement, this.cardUrl)
    }

    updateTouched(isTouched: boolean) {
        this.hasBeenTouched = isTouched;
    }

    handleResults(isValid: boolean, errors: Def.ValidationError[]) {
        if (this.hasBeenTouched && !isValid && errors.length > 0) {
            this.errorMessage = errors[0].description;
        } else {
            this.errorMessage = null;
        }
    }
}

